import styled from 'styled-components';

export const DisclaimerTextContainer = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: end;
  padding: 0 100px;

  p {
    font-size: 10px;
    color: #4c4c4c;
  }
`;
